import '../styles/app.scss';

// Getting our breakpoint for javascript
window.Breakpoint = {};

Breakpoint.refreshValue = function () {
	this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
};

$(window).resize(function () {
	Breakpoint.refreshValue();
}).resize();


// Libs
import PubSub from "underpub-js";
import Sitewide from "./classes/Sitewide";
import ComponentsLoader from "./classes/ComponentsLoader";

// Components Import -- DO NOT REMOVE COMMENT!
import PropertyDetail from "../../templates/_components/molecules/Detail/PropertyDetail/PropertyDetail";
import MiniMap from "../../templates/_components/elements/Maps/MiniMap/MiniMap";
import ButtonSecondary from "../../templates/_components/atoms/Buttons/ButtonSecondary/ButtonSecondary";
import ListingFilters from "../../templates/_components/elements/Listings/ListingFilters/ListingFilters";
import CallToAction from "../../templates/_components/elements/BasicContent/CallToAction/CallToAction";
import MapStandard from "../../templates/_components/molecules/Maps/MapStandard/MapStandard";
import DevNewsListings from "../../templates/_components/molecules/ListingsPages/DevNewsListings/DevNewsListings";
import PropertyListings from "../../templates/_components/molecules/ListingsPages/PropertyListings/PropertyListings";
import CardListingWide from "../../templates/_components/elements/Cards/CardListingWide/CardListingWide";
import SearchListings from "../../templates/_components/molecules/ListingsPages/SearchListings/SearchListings";
import Search from "../../templates/_components/atoms/Global/Search/Search";
import VideoLoop from "../../templates/_components/atoms/Media/VideoLoop/VideoLoop";
import NewsletterPopup from "../../templates/_components/molecules/Global/NewsletterPopup/NewsletterPopup";
import BlockQuote from "../../templates/_components/elements/BasicContent/BlockQuote/BlockQuote";
import ContentTextMedia from "../../templates/_components/molecules/Content/ContentTextMedia/ContentTextMedia";
import NewsletterForm from "../../templates/_components/elements/Forms/NewsletterForm/NewsletterForm";
import FormWithInfoItems from "../../templates/_components/molecules/Form/FormWithInfoItems/FormWithInfoItems";
import Form from "../../templates/_components/elements/Forms/Form/Form";
import InterviewListings from "../../templates/_components/molecules/ListingsPages/InterviewListings/InterviewListings";
import CardListingHorizontal from "../../templates/_components/elements/Cards/CardListingHorizontal/CardListingHorizontal";
import NewsListings from "../../templates/_components/molecules/ListingsPages/NewsListings/NewsListings";
import Callout from "../../templates/_components/molecules/Callout/Callout/Callout";
import ButtonNumber from "../../templates/_components/atoms/Buttons/ButtonNumber/ButtonNumber";
import Pagination from "../../templates/_components/elements/Global/Pagination/Pagination";
import InsightListings from "../../templates/_components/molecules/ListingsPages/InsightListings/InsightListings";
import VideoCentered from "../../templates/_components/molecules/Media/VideoCentered/VideoCentered";
import VideoPlayer from "../../templates/_components/elements/Media/VideoPlayer/VideoPlayer";
import CallToActionStandard from "../../templates/_components/molecules/CallToAction/CallToActionStandard/CallToActionStandard";
import Banner from "../../templates/_components/molecules/Global/Banner/Banner";
import HeroComplex from "../../templates/_components/molecules/Hero/HeroComplex/HeroComplex";
import Footer from "../../templates/_components/molecules/Global/Footer/Footer";
import ListingThreeUp from "../../templates/_components/molecules/Listings/ListingThreeUp/ListingThreeUp";
import ListingMixed from "../../templates/_components/molecules/Listings/ListingMixed/ListingMixed";
import ListingTwoUp from "../../templates/_components/molecules/Listings/ListingTwoUp/ListingTwoUp";
import InsightDetail from "../../templates/_components/molecules/Detail/InsightDetail/InsightDetail";
import ShareLinks from "../../templates/_components/elements/Misc/ShareLinks/ShareLinks";
import Image from "../../templates/_components/elements/BasicContent/Image/Image";
import TextContent from "../../templates/_components/elements/BasicContent/TextContent/TextContent";
import NewsDetail from "../../templates/_components/molecules/Detail/NewsDetail/NewsDetail";
import IframeEmbed from "../../templates/_components/elements/Media/IframeEmbed/IframeEmbed";
import InterviewDetail from "../../templates/_components/molecules/Detail/InterviewDetail/InterviewDetail";
import Hamburger from "../../templates/_components/atoms/Global/Hamburger/Hamburger";
import ModalHeader from "../../templates/_components/molecules/Modal/ModalHeader/ModalHeader";
import HeaderNavigation from "../../templates/_components/elements/Global/HeaderNavigation/HeaderNavigation";
import Header from "../../templates/_components/molecules/Global/Header/Header";
import HeroBasic from "../../templates/_components/molecules/Hero/HeroBasic/HeroBasic";
import ButtonTag from "../../templates/_components/atoms/Buttons/ButtonTag/ButtonTag";
import CardListing from "../../templates/_components/elements/Cards/CardListing/CardListing";
import ResponsiveImage from "../../templates/_components/atoms/Media/ResponsiveImage/ResponsiveImage";
import ButtonPrimary from "../../templates/_components/atoms/Buttons/ButtonPrimary/ButtonPrimary";
import Intro from "../../templates/_components/elements/Global/Intro/Intro";
import ListingFourUp from "../../templates/_components/molecules/Listings/ListingFourUp/ListingFourUp";
import BreakpointIndicator from "../../templates/_components/atoms/Global/BreakpointIndicator/BreakpointIndicator";;

$(document).ready(function () {

	var components = [
		// Components Loader -- DO NOT REMOVE COMMENT!
{handle: ".mol-PropertyDetail", require: PropertyDetail },
{handle: ".el-MiniMap", require: MiniMap },
{handle: ".atom-ButtonSecondary", require: ButtonSecondary },
{handle: ".el-ListingFilters", require: ListingFilters },
{handle: ".el-CallToAction", require: CallToAction },
{handle: ".mol-MapStandard", require: MapStandard },
{handle: ".mol-DevNewsListings", require: DevNewsListings },
{handle: ".mol-PropertyListings", require: PropertyListings },
{handle: ".el-CardListingWide", require: CardListingWide },
{handle: ".mol-SearchListings", require: SearchListings },
{handle: ".atom-Search", require: Search },
{handle: ".atom-VideoLoop", require: VideoLoop },
{handle: ".mol-NewsletterPopup", require: NewsletterPopup },
{handle: ".el-BlockQuote", require: BlockQuote },
{handle: ".mol-ContentTextMedia", require: ContentTextMedia },
{handle: ".el-NewsletterForm", require: NewsletterForm },
{handle: ".mol-FormWithInfoItems", require: FormWithInfoItems },
{handle: ".el-Form", require: Form },
{handle: ".mol-InterviewListings", require: InterviewListings },
{handle: ".el-CardListingHorizontal", require: CardListingHorizontal },
{handle: ".mol-NewsListings", require: NewsListings },
{handle: ".mol-Callout", require: Callout },
{handle: ".atom-ButtonNumber", require: ButtonNumber },
{handle: ".el-Pagination", require: Pagination },
{handle: ".mol-InsightListings", require: InsightListings },
{handle: ".mol-VideoCentered", require: VideoCentered },
{handle: ".el-VideoPlayer", require: VideoPlayer },
{handle: ".mol-CallToActionStandard", require: CallToActionStandard },
{handle: ".mol-Banner", require: Banner },
{handle: ".mol-HeroComplex", require: HeroComplex },
{handle: ".mol-Footer", require: Footer },
{handle: ".mol-ListingThreeUp", require: ListingThreeUp },
{handle: ".mol-ListingMixed", require: ListingMixed },
{handle: ".mol-ListingTwoUp", require: ListingTwoUp },
{handle: ".mol-InsightDetail", require: InsightDetail },
{handle: ".el-ShareLinks", require: ShareLinks },
{handle: ".el-Image", require: Image },
{handle: ".el-TextContent", require: TextContent },
{handle: ".mol-NewsDetail", require: NewsDetail },
{handle: ".el-IframeEmbed", require: IframeEmbed },
{handle: ".mol-InterviewDetail", require: InterviewDetail },
{handle: ".atom-Hamburger", require: Hamburger },
{handle: ".mol-ModalHeader", require: ModalHeader },
{handle: ".el-HeaderNavigation", require: HeaderNavigation },
{handle: ".mol-Header", require: Header },
{handle: ".mol-HeroBasic", require: HeroBasic },
{handle: ".atom-ButtonTag", require: ButtonTag },
{handle: ".el-CardListing", require: CardListing },
{handle: ".atom-ResponsiveImage", require: ResponsiveImage },
{handle: ".atom-ButtonPrimary", require: ButtonPrimary },
{handle: ".el-Intro", require: Intro },
{handle: ".mol-ListingFourUp", require: ListingFourUp },
		{
			handle: ".atom-BreakpointIndicator",
			require: BreakpointIndicator
		},
	];

	var sitewide = new Sitewide();
	sitewide.init();

	// Getting our components loading going
	window.componentsLoader = new ComponentsLoader({
		components: components
	});
	window.componentsLoader.initScreen();

	// setting our breakpoint value
	Breakpoint.refreshValue();

});
